export const formatPercentChange = (value?: number) => {
  if (value === undefined || !Number.isFinite(value)) return undefined
  const abs = Math.abs(value).toFixed(2)
  if (value > 0) {
    return { text: `↑ ${abs}%`, className: 'text-kodiak-accent-success' }
  }
  if (value < 0) {
    return { text: `↓ ${abs}%`, className: 'text-kodiak-accent-error' }
  }
  return { text: `${abs}%`, className: 'text-gray-400' }
}
